module.exports = __webpack_public_path__ + "img/ser-img3.7505481c.png";